import { render } from "./Warning.vue?vue&type=template&id=5991207c&scoped=true&ts=true"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"

import "./Warning.vue?vue&type=style&index=0&id=5991207c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5991207c"]])

export default __exports__